import { createContext, useContext, useEffect, useState } from "react";
import { setBrandCache, setSiteCache } from "@/lib/card";
import { Navigate } from "react-router-dom";
import { api, TOKEN_KEY } from "@/lib/api";

const AuthCtx = createContext(null);
const SA_KEY = "pvc_sa_token";

const loadBrand = () => Promise.all([
  api.get("/brand").then((r) => setBrandCache(r.data)).catch(() => {}),
  api.get("/site").then((r) => setSiteCache(r.data)).catch(() => {}),
]);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem(TOKEN_KEY)) return setUser(false);
    api.get("/auth/me").then(async (r) => { if (r.data.role !== "superadmin") await loadBrand(); setUser(r.data); }).catch(() => {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(SA_KEY);
      setUser(false);
    });
  }, []);

  const handle = async ({ data }) => {
    if (data.pending) return data;
    localStorage.setItem(TOKEN_KEY, data.token);
    const me = await api.get("/auth/me").then((r) => r.data).catch(() => data.user);
    if (me.role !== "superadmin") await loadBrand();
    setUser(me);
    return me;
  };

  const login = (email, password) => api.post("/auth/login", { email, password }).then(handle);
  const register = (name, email, password, extra = {}) => api.post("/auth/register", { name, email, password, ...extra }).then(handle);
  const impersonate = (token) => {
    localStorage.setItem(SA_KEY, localStorage.getItem(TOKEN_KEY));
    localStorage.setItem(TOKEN_KEY, token);
    window.location.assign("/");
  };
  const exitImpersonation = () => {
    localStorage.setItem(TOKEN_KEY, localStorage.getItem(SA_KEY));
    localStorage.removeItem(SA_KEY);
    window.location.assign("/admin");
  };
  const logout = async () => {
    if (localStorage.getItem(SA_KEY)) return exitImpersonation();
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, login, register, logout, impersonate, exitImpersonation, acceptAuth: (data) => handle({ data }) }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);

export function Protected({ children, superadmin = false }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen grid place-items-center text-slate-400 font-mono text-xs" data-testid="auth-loading">Loading studio…</div>;
  if (!user) return <Navigate to="/login" replace />;
  const isSa = user.role === "superadmin";
  if (superadmin && !isSa) return <Navigate to="/" replace />;
  if (!superadmin && isSa) return <Navigate to="/admin" replace />;
  return children;
}
